import round from 'lodash/round';
import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextProps } from '@components/Text/Text.types';
import classnames from 'classnames';

interface Props extends ComponentPropsWithRef<'span'> {
  amount?: number | null;
  unit?: string;
  variant?: 'card' | 'table' | 'accordion';
  textProps?: TextProps;
  className?: string;
}

function getFlavour(amount: number): TextProps['flavour'] {
  switch (true) {
    case amount < 0:
      return 'red';
    case amount > 0:
      return 'green';
    default:
      return 'dark';
  }
}

const StockVariation: FC<Props> = ({ className, amount = 0, unit = '', variant = 'card', textProps = {}, ...rest }) => {
  const { variant: textVariant, tag = 'span', ...restTextProps } = textProps;
  const flavour = getFlavour(amount || 0);

  const prefix = amount === null ? '' : amount < 0 ? '-' : '+';
  const formatedPrice =
    amount === null || amount === undefined ? '- ' : Math.abs(round(amount, 2)).toFixed(2).replace('.', ',');
  const formattedAmount = `${prefix}${formatedPrice} ${unit}`;
  function buildTextVariant() {
    if (textVariant) {
      return textVariant;
    }
    if (variant === 'accordion') {
      return 'h6';
    }
    if (variant === 'table') {
      return 'tiny-title';
    }
    return 'h3';
  }

  const rootClass = classnames('inline-flex', 'align-center', className);
  return (
    <span className={rootClass} {...rest}>
      <Text flavour={flavour} tag={tag} variant={buildTextVariant()} {...restTextProps}>
        {formattedAmount}
      </Text>
    </span>
  );
};

export { StockVariation };
